export default __webpack_public_path__ + "static/media/banner-video.48f66c65.mp4";